module.exports = __webpack_public_path__ + "img/appIcon-fiscal--Status__warning.faf79715.svg";